// Local storage keys
export const LsKeys = {
    paletteType: 'paletteType',
    signInRedirect: 'signInRedirect',
};